/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import cx from 'classnames';
import azCommonStyles from '../../../theme/globals.module.scss';
import { useLabel } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import NextImage from '@/components/NextImage';

const ErrorComponent = () => {
  const altImageText = useLabel('label_error_somethingNotworking_alt_image');
  const contentText = useLabel('label_error_somethingNotworking');

  return (
    <div id="error-page-content" className={styles.errorCompWrapper}>
      <div
        className={cx(
          azCommonStyles['az-subtitle-3-regular'],
          azCommonStyles['az-align-center'],
          styles.errorCompP,
        )}
      >
        <NextImage
          src="/images/icon-oops.svg"
          alt={altImageText}
          className={styles.errorEngineImage}
          width={137}
          height={88}
        />
        {contentText}
      </div>
    </div>
  );
};

export default ErrorComponent;
